import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, { FEATURE_FLAGS } from "../../../../constants/Define";
import RateCodeList from './RateCodeList';

let permisionActions = [];
class RateCode extends Component {

    state = {
        filters: {
            pageSize: this.props.rateCodeState.pageSize,
            pageIndex: this.props.rateCodeState.pageIndex,
        }
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATE_CODE);
        this.props.getRateCodeList(this.state.filters);
    }

    render() {
        const { t } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, rateCodes } = this.props.rateCodeState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'ratecode'}
                        titleHeader={t('navigation.ratecode')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Link to={`/ratecode/action`}
                                    className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            }
                            </Fragment>
                        }
                    />
                    <RateCodeList loading={isFetching}
                        permisions={permisionActions}
                        rateCodes={rateCodes}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onLockRateCode={this.lockRateCode}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onChangeLanguage = () => {
        this.props.getRateCodeList(this.state.filters);
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.getRateCodeList(newFilters);
    };

    lockRateCode = (rateCode)=>{
        this.props.lockRateCode(rateCode, this.state.filters);
    }
}


export default RateCode;
